import React from 'react';

import { ComponentProps } from './interfaces';
import * as Styled from './styled';

export const Table: React.FC<ComponentProps> = ({ orderedTableColumns, tableRows }) => {
  return (
    <Styled.Table>
      <thead>
        <tr>
          {orderedTableColumns.map(tableColumn => {
            const { id, key } = tableColumn;
            return <Styled.TableHeader key={id}>{key}</Styled.TableHeader>;
          })}
        </tr>
      </thead>
      <tbody>
        {tableRows.map(row => {
          const { id, items } = row;
          return (
            <Styled.TableRow key={id}>
              {orderedTableColumns.map(tableColumn => {
                const { key } = tableColumn;
                const columnValue = items.find(item => item.key === key);
                if (columnValue) {
                  return (
                    <Styled.TableItem key={columnValue.id}>{columnValue.value}</Styled.TableItem>
                  );
                } else {
                  return <Styled.TableItem key={`${id}_${key}`} />;
                }
              })}
            </Styled.TableRow>
          );
        })}
      </tbody>
    </Styled.Table>
  );
};

export default Table;
